// extracted by mini-css-extract-plugin
export default {"DashboardBody":"DashboardBody_DashboardBody__AySDr"};